import { Keys, OrderFormData, OrderResponseMessage, TempOrder, TradeType } from '@eih-netbroker/common';
import { useCallback } from 'react';
import { useLocale } from '../../../../../context/NbLocalizationContext';
import { NbButton } from '../../../../../shared/components/button/Button';
import { useOrderState } from '../../OrderStateContext';
import classes from './OrderModalBottomNavigationButtons.module.scss';

type OrderFooterPrimaryButtonProps = {
  isLoading: boolean;
  tempOrder?: TempOrder;
  warnings?: OrderResponseMessage[];
  onContinue: () => void;
  onBack: (shouldResetFormToDefaults: boolean) => void;
  onClose: (shouldResetFormToDefaults: boolean) => void;
  orderState: OrderFormData;
};

export const OrderFooterPrimaryButton = ({
  tempOrder,
  isLoading,
  onContinue,
  onBack,
  onClose,
  orderState,
  warnings,
}: OrderFooterPrimaryButtonProps) => {
  const { translation } = useLocale();
  const { smsCodeError, calculatedCostState } = useOrderState();
  const handleBack = useCallback(() => onBack(false), [onBack]);
  const handleClose = useCallback(() => onClose(false), [onClose]);

  if (warnings && warnings?.some(message => message.msgType === 'error')) {
    return (
      <NbButton
        isLoading={isLoading}
        onClick={handleBack}
        className={classes.button}
      >
        {translation.general.back}
      </NbButton>
    );
  }

  if (warnings) {
    return (
      <NbButton
        isLoading={isLoading}
        onClick={onContinue}
        className={classes.button}
      >
        {translation.general.continue}
      </NbButton>
    );
  }

  if (tempOrder?.showWarningConfirmation && tempOrder.messages?.some(message => message.msgType === 'error')) {
    return (
      <NbButton
        isLoading={isLoading}
        onClick={handleBack}
        className={classes.button}
      >
        {translation.general.back}
      </NbButton>
    );
  }

  if (tempOrder?.showWarningConfirmation) {
    return (
      <NbButton
        isLoading={isLoading}
        onClick={onContinue}
        className={classes.button}
      >
        {translation.general.continue}
      </NbButton>
    );
  }

  if (tempOrder?.showConfirmation) {
    return (
      <NbButton
        data-testid="order-confirm-confirm-button"
        disabled={calculatedCostState?.isLoading || calculatedCostState?.hasError}
        isLoading={isLoading}
        onClick={onContinue}
        className={classes.button}
      >
        {orderState.tradeType === TradeType.Buy
          ? translation.newOrderConfirm.confirmBuy
          : translation.newOrderConfirm.confirmSell}
      </NbButton>
    );
  }

  if (
    tempOrder?.showSmsConfirmation &&
    smsCodeError?.errorCode === Keys.ErrorCode.twoFactor.orderSmsConfirmationError
  ) {
    return (
      <NbButton
        onClick={handleClose}
        className={classes.button}
      >
        {translation.general.ok}
      </NbButton>
    );
  }

  return null;
};
